import type { ReactNode } from "react";

import { SidebarInset, SidebarProvider } from "../primitives/sidebar";
import { TenkoAppShellBreadcrumbProvider } from "./TenkoAppShellBreadcrumbProvider";
import { TenkoAppShellHeader } from "./TenkoAppShellHeader";

type TenkoAppShellProps = {
  sidebar: ReactNode;
  headerActions?: ReactNode;
  children?: ReactNode;
};

export function TenkoAppShell({ sidebar, headerActions, children }: TenkoAppShellProps) {
  return (
    <TenkoAppShellBreadcrumbProvider>
      <SidebarProvider className="h-svh overflow-hidden">
        {sidebar}
        <SidebarInset className="min-h-0 overflow-hidden">
          <TenkoAppShellHeader actions={headerActions} />
          <div className="flex flex-1 min-h-0 flex-col overflow-y-auto">{children}</div>
        </SidebarInset>
      </SidebarProvider>
    </TenkoAppShellBreadcrumbProvider>
  );
}
